import React from 'react';
import PlayerIdentity from '../../shared/PlayerIdentity';
import WWIcon from '../../shared/assets/WW.png';

const ContractListPlayerRow = ({ player }) => {
    const marketValue = Number(player.auction_value);
    const hasMarketValue = player.auction_value != null
      && Number.isFinite(marketValue);

    return (
      <tr>
        <td className="name-td">
            <PlayerIdentity
                player={player}
                icon={player.player_added ? WWIcon : undefined}
            />
        </td>
        <td>{player.salary}</td>
        <td>{hasMarketValue ? Math.round(marketValue) : '—'}</td>
        <td>
          <img src={player.team_logo_url} alt={`${player.player_name} team logo`} className="team-logo" />
        </td>

      </tr>
    );
};

export default ContractListPlayerRow;
